export const shadows = {
  banner: "0px 4px 8px rgba(0, 0, 0, 0.25)",
  button: "0px 4px 4px rgba(28, 35, 53, 0.1)",
  sideModal: "-4px 0px 8px rgba(28, 35, 53, 0.15)",
  dialog: "0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)",
  divider: "0px 2px 2px -2px #B8C5D6",
};
